import gtm from '@/utils/gtm';

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import './index.scss';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

export interface EfNavProductItemProps {
    type: string;
    title: string;
}
interface EfNavProductProps {
    /**
     * 默认选择tab
     */
    selectType?: string;
    /**
     * 通过组件外部状态控制tab
     */
    currentSelectType?: string;
    /**
     * 展示方式
     */
    type?: 'default' | 'select';
    /**
     * 主题色
     */
    theme?: 'default' | 'white';
    /**
     * 左侧名称
     */
    name?: string;
    /**
     * buy 配置
     */
    buyItem?: any;
    /**
     * tab列表
     */
    list?: EfNavProductItemProps[];
    /**
     * 点击tab回调
     */
    callback?: any;
    /**
     * 点击购买回调
     */
    buyCallback?: any;
    /**
     * 站点
     */
    locale?: string;
}

// 根据type获取item
const getSelectItemFromType = (list: EfNavProductItemProps[], selectType: string) => {
    const list2 = list || [];
    for (let i = 0; i < list2.length; i++) {
        const item = list2[i];
        if (item.type === selectType) {
            return item;
        }
    }

    return list[0] || {};
};
/**
 * 维护:谢保林
 *
 * 产品导航
 */
const EfNavProduct: React.FC<EfNavProductProps> = ({
    currentSelectType,
    selectType,
    theme,
    type,
    name,
    buyItem = {},
    list = [],
    callback,
    buyCallback,
    locale,
}) => {
    const prefixCls = `ef-nav-product`;
    const classes = classNames(prefixCls, {
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-type-${type}`]: type,
    });
    const defaultType = selectType || list[0]?.type || 'Product';
    const [activeType, setActiveType] = useState(defaultType);
    const [activeItem, setActiveItem] = useState(getSelectItemFromType(list, defaultType));
    const [selectOpen, setSelectOpen] = useState(false); //在 type = select 时,下拉是否打开
    // 点击单项
    const itemHandle = (item: any) => {
        setActiveType(item.type);
        setActiveItem(item);
        callback && callback(item);
        if (type === 'select') {
            setSelectOpen(false);
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: item.title,
                product_name: name,
            });
        } catch (error) {}
    };
    // 点击购买
    const buyHandle = () => {
        if (buyItem?.href) {
            let hrefB = buyItem?.href || '';
            if (locale) {
                hrefB = saveCookieForShopify(hrefB, locale);
                saveAICookieForShopify(hrefB, locale);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: name,
                    position: 'Product Details Navigation',
                });
            }
            window.open(hrefB, buyItem.href.indexOf(window.location.pathname) > -1 ? '_self' : '_blank');
        } else {
            setActiveType(buyItem.type);
            try {
                const buyUrl = buyItem?.href || location.href || 'none';
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: 'Top',
                    button_name: buyItem.title,
                    url: buyUrl,
                });
            } catch (error) {}
        }
        buyCallback && buyCallback(buyItem);
    };
    // 切换下拉选择
    const toggleSelectHandle = () => {
        if (type === 'select') {
            const selectOpen2 = !selectOpen;
            setSelectOpen(selectOpen2);
        }
    };

    // 特殊情况下需要使用外部控制选中状态
    // us —— power-kits-5kva-48v-power-system 站点 buyNow 按钮跳转 Bundles
    useEffect(() => {
        if (!currentSelectType) return;
        setActiveType(currentSelectType);
    }, [currentSelectType]);
    return (
        <div className={classes} id="global-nav-product">
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-l`}>{name}</div>
                <div className={`${prefixCls}-r1`}>
                    {type === 'select' && (
                        <div className={`${prefixCls}-r1-select`} onClick={toggleSelectHandle}>
                            {activeItem.title}
                            <span className={`${prefixCls}-r1-select-icon`}></span>
                        </div>
                    )}
                    <ul className={`${prefixCls}-r1-in${selectOpen ? ` ${prefixCls}-select-open` : ''}`}>
                        {list?.map((item: EfNavProductItemProps, index: number) => {
                            if (!item.title) {
                                return null;
                            }
                            return (
                                <li
                                    className={`${prefixCls}-item-a${activeType === item.type ? ` ${prefixCls}-active` : ''}`}
                                    key={index}
                                    onClick={() => {
                                        itemHandle(item);
                                    }}
                                >
                                    {item.title}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className={`${prefixCls}-r2`}>
                    {buyItem?.title && (buyItem?.href || buyItem?.type === 'Bundles') && (
                        <button className={`${prefixCls}-item-b ${prefixCls}-item-b-buy`} onClick={buyHandle}>
                            {buyItem.title}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EfNavProduct;
